<template>
  <div>
    <template-item v-if="hasType" label="填写方式">
      <input-mode-chooser v-model="inputModeProxy" :modes="modes" />
    </template-item>
    <template v-if="hasMode">
      <area-single-selector-constraint
        v-if="isSingleType"
        :type="bizType"
        :allowed-values.sync="allowedValuesProxy"
        :forbidden-values.sync="forbiddenValuesProxy"
      />
    </template>
  </div>
</template>

<script>
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
import InputModeChooser from "@/components/selector/InputModeChooser";
import {
  MultiSelector,
  SingleSelector,
} from "@/components/excel/schema/value/mode";
import AreaSingleSelectorConstraint from "@/components/excel/designer/configure/value/area/AreaSingleSelectorConstraint";
import "@/utils/extensions/libs/ArrayExtension";
import { AreaType } from "@/components/excel/schema/value/catalog";
import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/value/type/area";

export default {
  name: "area-value-configure",
  components: {
    AreaSingleSelectorConstraint,
    InputModeChooser,
    TemplateItem,
  },
  props: {
    type: {
      type: Number,
    },
    inputMode: {
      type: Number,
    },
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
  },
  watch: {
    type(type) {
      if (type === undefined || null) {
        this.modes = [];
        this.mode = null;
        return;
      }
      if (!this.types.some((it) => it.value === type)) {
        this.updateType(AreaType.default);
        return;
      }
      this.bizType = type;
      const { modes, mode } = this.findMode(this.bizType, this.mode);
      this.modes = modes;
      if (mode !== this.mode) {
        this.updateMode(mode);
      }
      console.log("type变了");
    },
    inputMode(inputMode) {
      if (this.modes.some((it) => it.value === inputMode)) {
        this.mode = inputMode;
      } else {
        const { mode } = this.findMode(this.bizType);
        this.mode = mode;
      }
      console.log("inputMode变了");
    },
    bizType(bizType) {
      if (bizType === undefined || bizType === null) {
        this.modes = [];
      } else {
        const { modes, mode } = this.findMode(bizType, this.mode);
        this.modes = modes;
        if (mode !== this.mode) {
          this.updateMode(mode);
        }
      }
      console.log("bizType变了");
    },
  },
  computed: {
    typeProxy: {
      get() {
        return this.bizType;
      },
      set(value) {
        this.updateType(value);
      },
    },
    inputModeProxy: {
      get() {
        return this.mode;
      },
      set(value) {
        this.updateMode(value);
      },
    },
    hasType() {
      const { bizType } = this;
      return bizType !== null && bizType !== undefined;
    },
    hasMode() {
      const { mode } = this;
      return mode !== null && mode !== undefined;
    },
    isSingleType() {
      const { bizType } = this;
      if (bizType === undefined || bizType === null) {
        return false;
      }
      return (
        bizType === ProvinceOption.value ||
        bizType === CityOption.value ||
        bizType === CountyOption.value
      );
    },
    allowedValuesProxy: {
      get() {
        return this.$props.allowedValues;
      },
      set(value) {
        this.emitChangeAllowedValues(value);
      },
    },
    forbiddenValuesProxy: {
      get() {
        return this.$props.forbiddenValues;
      },
      set(value) {
        this.emitChangeForbiddenValues(value);
      },
    },
  },
  mounted() {
    const { type, inputMode } = this.$props;
    if (
      type === undefined ||
      type === null ||
      !this.types.some((it) => it.value === type)
    ) {
      this.emitChangeType(this.bizType);

      const { modes, mode } = this.findMode(this.bizType, inputMode);
      this.modes = modes;
      if (mode !== this.mode) {
        this.updateMode(mode);
      }
    } else if (type !== this.bizType) {
      this.bizType = type;
      const { modes, mode } = this.findMode(type, inputMode);
      this.modes = modes;
      if (mode !== this.mode) {
        this.updateMode(mode);
      }
    }
    console.log("地区类型 挂载了");
  },
  data() {
    const types = AreaType.options;
    const bizType = AreaType.default;
    const single = SingleSelector.value;
    const multi = MultiSelector.value;
    const initMode = () => {
      const typeObject = types.find((it) => it.value === bizType);
      if (typeObject && typeObject.mode) {
        const modes = typeObject.mode.options;
        const mode = typeObject.mode.default;
        return { modes, mode };
      } else {
        return { modes: [], mode: null };
      }
    };
    const { modes, mode } = initMode();
    return {
      types,
      bizType,
      modes,
      mode,
      modeValue: {
        single,
        multi,
      },
    };
  },
  methods: {
    emitChangeType(value) {
      this.$emit("update:type", value);
      this.$emit("change-type", value);
    },
    emitChangeInputMode(value) {
      this.$emit("update:input-mode", value);
      this.$emit("change-input-mode", value);
    },
    emitChangeAllowedValues(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    emitChangeForbiddenValues(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
    updateType(value) {
      this.bizType = value;
      this.emitChangeType(value);
    },
    updateMode(value) {
      this.mode = value;
      this.emitChangeInputMode(value);
    },
    findMode(type, mode) {
      if (type === undefined || type === null) {
        return { modes: [], mode: null };
      }
      const obj = this.types.find((it) => it.value === type);
      if (obj && obj.mode) {
        const modes = obj.mode.options;
        if (
          mode !== undefined &&
          mode !== null &&
          modes.some((it) => it.value === mode)
        ) {
          return { modes, mode };
        }
        const defaultMode = obj.mode.default;
        return { modes, mode: defaultMode };
      }
      return { modes: [], mode: null };
    },
  },
};
</script>
